import { omit } from "lodash";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { THEMES } from "../constants";
import { Theme } from "../types";

type State = {
    theme: Theme;
    scrollPositions: Record<string, number>;
};

type Action = {
    setTheme: (theme: Theme) => void;
    setScrollPosition: (key: string, position: number) => void;
    resetScrollPosition: (key: string) => void;
};

const initialState: State = {
    theme: THEMES.LIGHT,
    scrollPositions: {},
};

export const useUIStore = create(
    persist(
        devtools<State & Action>((set) => ({
            ...initialState,

            setTheme: (theme: Theme) => set({ theme }),

            setScrollPosition: (key, position) =>
                set((state) => ({
                    scrollPositions: {
                        ...state.scrollPositions,
                        [key]: position,
                    },
                })),

            resetScrollPosition: (key) =>
                set((state) => ({
                    scrollPositions: omit(state.scrollPositions, key),
                })),
        })),
        {
            name: "ui-storage",
        }
    )
);
